import defaultState from 'redux/defaultState';

export default (data = defaultState.user, action) => {
  if (action.type === 'UESR_REPLACE') {
    return {
      ...action.payload
    };
  }
  return data;
};
